module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e2088760"
    }
  }, [_c('b', [_vm._v("GAZPACHO WITH CILANTRO CREAM")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e2089260"
    }
  }, [_c('b', [_c('i', [_vm._v("Recipes for this full-flavored, uncooked tomato-based soup abound. Ours is topped with a dollop of cilantro-spiked sour cream, a tasty combination.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2090760"
    }
  }, [_c('b', [_vm._v("Prep: 30 minutes plus chilling")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2091260"
    }
  }, [_vm._v("2 medium cucumbers (8 ounces each), peeled")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2091560"
    }
  }, [_vm._v("1 yellow pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2091860"
    }
  }, [_vm._v("¼ small red onion")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2092760"
    }
  }, [_vm._v("2 pounds ripe tomatoes (5 medium), peeled, seeded, "), _c('br'), _vm._v(" and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2093460"
    }
  }, [_vm._v("½ to 1 small jalapeño chile, seeded")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2094660"
    }
  }, [_vm._v("3 tablespoons fresh lime juice")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2094960"
    }
  }, [_vm._v("2 tablespoons extra-virgin olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2095360"
    }
  }, [_vm._v("¾ plus ⅛ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2097060"
    }
  }, [_vm._v("¼ cup reduced-fat sour cream or plain "), _c('br'), _vm._v(" low-fat yogurt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2098360"
    }
  }, [_vm._v("1 tablespoon milk")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2098660"
    }
  }, [_vm._v("4 teaspoons chopped fresh cilantro")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e2099160"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Chop half of 1 cucumber, half of yellow pepper, and all of onion into ¼-inch pieces; set aside. Cut remaining cucumbers and yellow pepper into large pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2101560"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" In blender or in food processor with knife blade attached, puree large pieces of cucumber and yellow pepper, tomatoes, jalapeño, lime juice, oil, and ¾ teaspoon salt until smooth. Pour puree into bowl; add cut-up cucumber, yellow pepper, and onion. Cover and refrigerate until well chilled, at least 6 hours or up to overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2105560"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Prepare cilantro cream: In small bowl, stir sour cream, milk, cilantro, and remaining ⅛ teaspoon salt until smooth. Cover and refrigerate.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2107760"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" To serve, top soup with dollops of cilantro cream. Makes about 5 cups or 4 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e2109060"
    }
  }, [_vm._v("Each serving: About 156 calories, 4g protein, 17g carbohydrate, 10g total fat (2g saturated), 6mg cholesterol, 545mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34420add","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c59_r1.vue
// module id = 243
// module chunks = 0